import { SurveyResults } from "./SurveyResults";
import { HistoricalSurveyResultsSetDto } from "@Dtos";
import { Metric } from "./Metric";
import { compareDatePart } from "@jcharlesworthuk/your-mum-core/dist/functions";

export class HistoricalSurveyResultsSet {
    constructor(public surveys: SurveyResults[]) {
    }

    includesDate(date: Date) {
        return this.surveys.some(x => compareDatePart(x.date, date) === 0);
    }

    get latestSurvey() {
        return this.surveys && this.surveys.length > 0 ? this.surveys[this.surveys.length - 1] : null;
    }

    latestSurveyWithMetric(metricId: string) {
        if (!this.surveys || this.surveys.length == 0) return null;
        let i = this.surveys.length - 1;
        while(i >= 0 && !this.surveys[i].metrics[metricId]) {
            i--;
        }
        if (i < 0) return null;
        return this.surveys[i].metrics[metricId] || null;
    }

    latestSurveyWithTeam(teamId: string) {
        if (!this.surveys || this.surveys.length == 0) return null;
        let i = this.surveys.length - 1;
        while(i >= 0 && !this.surveys[i].teamScores[teamId]) {
            i--;
        }
        if (i < 0) return null;
        return this.surveys[i].teamScores[teamId] || null;
    }


    static fromDto(dto: HistoricalSurveyResultsSetDto, metrics: { [metricId: string]: Metric}) {
        return new HistoricalSurveyResultsSet(dto.latestResults.map(x => SurveyResults.fromDto(x, metrics)));
    }
}

